/**
 * 后台语言识别（PRD §8.4）：链接中的语言参数 → 浏览器语言 → 设备地区 → 英语。
 * 词条用 @nexora/i18n 的后台组装（`<I18nProvider surface="admin">`，P0-06）：内置种子收录全部命名空间
 * （admin、*-admin、common、core-errors 等），缺译按"用户语言 → 英语 → 中文"兜底，永不显示词条编号
 * （platform REQ-8.4-002：A01–A57 的后台文案同样取自 admin.* 词条）。
 */
import { detectFromBrowser, type Lang } from '@nexora/i18n';

export function detectAdminLang(): Lang {
  const resolved = Intl.DateTimeFormat().resolvedOptions();
  return detectFromBrowser({
    search: window.location.search,
    languages: navigator.languages,
    language: navigator.language,
    resolvedLocale: resolved.locale,
    timeZone: resolved.timeZone,
  });
}
